module.exports = __webpack_public_path__ + "img/9_natalie_s.14162332.png";